import React from 'react';
import BootstrapSpinner from 'react-bootstrap/Spinner';

function Spinner() {
    return (
        <div
            style={{ textAlign: 'center' }}
        >
            <BootstrapSpinner 
                animation={'border'}
                role={'status'}
            >
                <span 
                    className={'visually-hidden'}
                >
                Loading...
                </span>
            </BootstrapSpinner>

        </div>
    );
}

export default Spinner;